import apiClient from '../service/api'

// GET Plans
export const getPlans = async (page) => {
  const { data } = await apiClient.get(`/v1/plans`, {
    params: { page },
  })
  return data
}

export const getPlanDetails = async (planId) => {
  const response = await apiClient.get(`/v1/admin/plans/${planId}`)
  return response.data
}
